import { useTranslation } from 'react-i18next'

const useDirection = () => {
  const { i18n: { language } } = useTranslation()

  return { dir: language === 'en' ? 'ltr' : 'rtl' }
}

export default useDirection
